import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    globalError: null,
    isErrorModalOpen: false,
};
export const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setGlobalError: (state, action) => {
            state.globalError = action.payload;
            state.isErrorModalOpen = true;
        },
        clearGlobalError: (state) => {
            state.globalError = null;
            state.isErrorModalOpen = false;
        },
    },
});
export const { setGlobalError, clearGlobalError } = errorSlice.actions;
export default errorSlice.reducer;
